import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { collection, onSnapshot, query } from 'firebase/firestore'
import { db } from '../firebase'
import { getSignedIn, getUserId } from '../reducks/users/selectors'
import {
  fetchProductsInCart,
  fetchProductsInFavorite,
} from '../reducks/users/operations'

// ユーザのカート/お気に入りを Firestore からリアルタイム同期するフック。
//
// 旧実装 (HeaderMenus 内) は docChanges の差分を既存配列に push して貯めていたため、
// リスナーが貼り直されると初回スナップショットで全件が 'added' として再生され、
// 既にデータの入った配列へ全件追記 → 重複していた。
//
// ここでは毎回 snapshot.docs から配列を「丸ごと再構築」して dispatch する。
// 何度購読し直しても結果が同じ（冪等）になり、重複が原理的に起きない。
//
// 単一の購読オーナーにするため、常駐コンポーネント (Header) から1回だけ呼ぶこと。
export const useUserCartFavoriteSync = () => {
  const dispatch = useDispatch()
  const userId = useSelector(getUserId)
  const isSignedIn = useSelector(getSignedIn)

  // サインアウト時に uid はクリアされないため、isSignedIn でもゲートして
  // 確実に購読解除されるようにする。
  useEffect(() => {
    if (!isSignedIn || !userId) return
    const cartRef = collection(db, 'users', userId, 'cart')
    const unsubscribe = onSnapshot(query(cartRef), (snapshot) => {
      const cart = snapshot.docs.map((doc) => ({
        ...doc.data(),
        cartId: doc.id,
      }))
      dispatch(fetchProductsInCart(cart))
    })
    return () => unsubscribe()
  }, [dispatch, isSignedIn, userId])

  useEffect(() => {
    if (!isSignedIn || !userId) return
    const favoriteRef = collection(db, 'users', userId, 'favorite')
    const unsubscribe = onSnapshot(query(favoriteRef), (snapshot) => {
      const favorite = snapshot.docs.map((doc) => ({
        ...doc.data(),
        favoriteId: doc.id,
      }))
      dispatch(fetchProductsInFavorite(favorite))
    })
    return () => unsubscribe()
  }, [dispatch, isSignedIn, userId])
}
